module.exports = __webpack_public_path__ + "img/manual-slots-03-edit-slot.f1e37d33.png";